/**
 * Phase 29 (Item 4) — pure URL/text → join-short-code parser.
 *
 * Extracted from `JoinQrScanner.tsx` so the URL-parsing logic
 * (where D88/D90/D91 lived) can be unit-tested in plain Node
 * without standing up a DOM, html5-qrcode, or camera mocks.
 *
 * Hyphens MUST be in the character class — production tenant slugs
 * like "artehaus-ph" would otherwise truncate at the dash and the
 * app would navigate to /j/artehaus (which 404s) instead of the
 * real /j/artehaus-ph. Bounds (2-64) match JoinShortCodeSchema in
 * api-zod.
 *
 * We deliberately preserve the slug's casing as printed on the
 * merchant's poster — the server lookup
 * (storage.findTenantByShortCode) is case-insensitive (D87) so
 * "BEANBAR", "beanbar", and "BeanBar" all resolve, but the URL bar
 * reads back what the merchant actually advertised.
 */

const JOIN_PATH_REGEX = /\/j\/([A-Za-z0-9-]{2,64})/u;
const BARE_SHORT_REGEX = /^[A-Za-z0-9-]{2,64}$/u;

export function extractShortCode(raw: string): string | null {
  const trimmed = raw.trim();
  const urlMatch = trimmed.match(JOIN_PATH_REGEX);
  if (urlMatch) return urlMatch[1];
  if (BARE_SHORT_REGEX.test(trimmed)) return trimmed;
  try {
    const u = new URL(trimmed);
    const m = u.pathname.match(JOIN_PATH_REGEX);
    if (m) return m[1];
  } catch {
    // Not a URL — fall through.
  }
  return null;
}
